// extracted by mini-css-extract-plugin
export default {"tabList":"style_tabList__DzUSU","title":"style_title__kB2+G"};